import { useState, useCallback } from 'react';

import { openGifModalAction, closeGifModalAction } from 'actions/gifModal';
import { useDispatch, useSelector } from 'react-redux';

import { IMAGE_UPLOAD_SUCCESS, IMAGE_UPLOAD_ERROR } from 'constants/ProjectConstants';

import { uploadPostMedia } from 'services/post';
import { showSuccessSnackbar, showErrorSnackbar } from 'services/snackbar';

export function useMediaUploadStatePost({ setImage, uploadedImage, uploadedGif, setGif }) {
  const [isGifModalOpen, setGifModalOpen] = useState(false);
  return useMediaUploadState({
    setImage,
    uploadedImage,
    setGif,
    uploadedGif,
    isGifModalOpen,
    setGifModalOpen,
  });
}

export function useMediaUploadStateComment({ setImage, uploadedImage, uploadedGif, setGif }) {
  const dispatch = useDispatch();
  const isGifModalOpen = useSelector((state) => state.gifModal.isOpen);
  const onSelect = useCallback(
    (gifUrl) => {
      setGif(gifUrl);
    },
    [setGif]
  );
  const openGifModal = useCallback(() => {
    dispatch(openGifModalAction({ onSelect }));
  }, [onSelect, dispatch]);

  const closeGifModal = useCallback(() => {
    dispatch(closeGifModalAction());
  }, [dispatch]);

  const toggleGifModal = useCallback(() => {
    if (isGifModalOpen) closeGifModal();
    else openGifModal();
  }, [isGifModalOpen, openGifModal, closeGifModal]);

  const state = useMediaUploadState({
    setImage,
    uploadedImage,
    setGif,
    uploadedGif,
    isGifModalOpen,
  });

  // we are using redux here that's why we needed to override the logic of toggleGifModal that we get from
  // useMediaUploadState as that gives the logic of local hooks state
  state.toggleGifModal = toggleGifModal;
  return state;
}

export function useMediaUploadState({ setImage, uploadedImage, uploadedGif, setGif, isGifModalOpen, setGifModalOpen }) {
  const dispatch = useDispatch();
  const [fileObject, setFileObject] = useState(null);
  const [uploading, setUploading] = useState(false);
  function uploadFile(file) {
    setUploading(true);
    setFileObject(file);
    return uploadPostMedia({ attachment: file })
      .then((media) => {
        // setUploadedFile(media);
        setImage(media);
        dispatch(showSuccessSnackbar(IMAGE_UPLOAD_SUCCESS));
      })
      .catch(() => dispatch(showErrorSnackbar(IMAGE_UPLOAD_ERROR)))
      .finally(() => setUploading(false));
  }

  function deleteFile() {
    setFileObject(null);
    // setUploadedFile(null);
    setImage(null);
  }

  function getFileUrl() {
    if (uploadedImage) return uploadedImage.url;
    if (fileObject) return URL.createObjectURL(fileObject);
    return '';
  }

  function toggleGifModal() {
    setGifModalOpen(!isGifModalOpen);
  }
  function onGifSelect(url) {
    setGif(url);
    toggleGifModal();
  }

  const fileUrl = getFileUrl();
  const gifUrl = uploadedGif ? uploadedGif.url : null;

  return {
    fileUrl,
    gifUrl,
    deleteFile,
    uploadFile,
    isGifModalOpen,
    setGifModalOpen,
    fileObject,
    setFileObject,
    uploading,
    setUploading,
    onGifSelect,
    toggleGifModal,
  };
}
